import classNames from 'classnames';
import React, { useRef, useEffect } from 'react';
import { Button } from '../button';
import { CloseIcon } from '../icons';
import styles from './Dialog.scss';

interface IframeDialogProps {
    iframeSrc: string;
    isOpen: boolean;
    onClose: () => void;
    isCloseButtonOnLeft?: boolean;
    height?: string;
    width?: string;
}

const bodyElement = document.querySelector('body')!;
const bodyClass = bodyElement.className;

const IframeDialog = function IframeDialog({
    iframeSrc,
    isOpen,
    onClose,
    isCloseButtonOnLeft,
    height = 'inherit',
    width = '666px',
} : IframeDialogProps) {
    const dialogRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        if (isOpen) {
            dialogRef.current?.showModal();
            // prevent scrolling when dialog is open
            bodyElement.className = bodyClass ? `${bodyClass} ` : '' + 'has-dialog';

            return;
        }

        dialogRef.current?.close();
        bodyElement.className = bodyClass;
    }, [isOpen]);

    return (
        <dialog
            ref={dialogRef}
            onCancel={onClose}
            className={classNames(styles.dialog, styles['iframe-dialog'])}
            style={{ width, height }}
        >
            <div>
                <span className={classNames(styles.dialog__close, {[styles['dialog--has-left-close']]: isCloseButtonOnLeft})}>
                    <Button
                        id="dialog-close-button"
                        appearance="icon"
                        onClick={onClose}
                    >
                        <CloseIcon size={24} />
                    </Button>
                </span>
                {isOpen && <iframe style={{ width, height }} src={iframeSrc} />}
            </div>
        </dialog>
    );
};

export default IframeDialog;
